module.exports = __webpack_public_path__ + "static/media/money4.eeab5c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/money4.png
// module id = 666
// module chunks = 0 1